import BaseFilterModal from "./BaseFilterModal";

const SaveFiltersModal = ({
  open,
  onClose,
  onSave,
  appliedFilters,
  isLoading = false,
}) => {
  return (
    <BaseFilterModal
      open={open}
      onClose={onClose}
      onSave={onSave}
      title="Save Filter"
      saveButtonText="Save"
      appliedFilters={appliedFilters}
      existingFilter={null}
      isLoading={isLoading}
    />
  );
};

export default SaveFiltersModal;
